import { useNamedRoutes } from "../../../NamedRoutes";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import { PermissionsSettingsProps } from "./types";

import
{
    useCustomerPermissions,
    useModifyCustomerPermissions
} from "../../../ReactData/customer";

import
{
    CustomerPermissions,
    InheritedPermission,
    permissionAllowed,
    permissionAvailable,
    permissionChecked
} from "@ews/react-data";
import { useMyPermissions } from "../../../Login/LoginProvider";


const PermissionsSettings: React.FC<PermissionsSettingsProps> = ({ customer, }) =>
{
    const { params } = useNamedRoutes();
    const { id } = params();

    const permission = useCustomerPermissions(id || "");

    const myPermissions = useMyPermissions();
    const allowedToEdit = permissionAllowed(myPermissions.createCustomer || 0);

    const modifyCustomerPermissions = useModifyCustomerPermissions();

    function saveCustomerPermission(data: CustomerPermissions)
    {
        if (!id) return;
        modifyCustomerPermissions(id, data);
    }

    return <>
        <SettingsCol>
            <SettingsCheckbox


                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERSCREATE"}
                disabled={allowedToEdit ? !permissionAvailable(permission.createUser!) : true}
                checked={permissionAllowed(permission.createUser!)}
                onChange={(checked) =>
                {
                    const createUser = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;

                    saveCustomerPermission({ createUser } as CustomerPermissions);
                }} />
            <SettingsCheckbox

                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CUSTOMERSCREATE"}
                disabled={allowedToEdit ? !permissionAvailable(permission.createCustomer!) : true}
                checked={permissionAllowed(permission.createCustomer!)}
                onChange={(checked) =>
                {
                    const createCustomer = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;

                    saveCustomerPermission({ createCustomer } as CustomerPermissions);
                }} />
            <SettingsCheckbox

                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSAVAILABLE"}
                disabled={allowedToEdit ? !permissionAvailable(permission.listAllSystems!) : true}
                checked={permissionAllowed(permission.listAllSystems!)}
                onChange={(checked) =>
                {
                    const listAllSystems = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;

                    saveCustomerPermission({ listAllSystems } as CustomerPermissions);
                }} />
            <SettingsCheckbox

                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONCREATE"}
                disabled={allowedToEdit ? !permissionAvailable(permission.grantSystemAccess!) : true}
                checked={permissionAllowed(permission.grantSystemAccess!)}
                onChange={(checked) =>
                {
                    const grantSystemAccess = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;

                    saveCustomerPermission({ grantSystemAccess } as CustomerPermissions);
                }} />
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSREQUESTVIEW"}
                disabled={allowedToEdit ? !permissionAvailable(permission.createShare!) : true}
                checked={permissionAllowed(permission.createShare!)}
                onChange={(checked) =>
                {
                    const createShare = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;
                    saveCustomerPermission({ createShare } as CustomerPermissions);
                }} />

        </SettingsCol>
        <SettingsCol>
            <SettingsCheckbox

                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSUSE"}
                disabled={allowedToEdit ? !permissionAvailable(permission.permitAccessLevel2!) : true}
                checked={permissionAllowed(permission.permitAccessLevel2!)}
                onChange={(checked) =>
                {
                    const permitAccessLevel2 = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;

                    saveCustomerPermission({ permitAccessLevel2 } as CustomerPermissions);
                    // setShowOperationOnlyButton(value);
                }} />
            <SettingsCheckbox

                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERS"}
                disabled={allowedToEdit ? !permissionAvailable(permission.permitAccessLevel3!) : true}
                checked={permissionAllowed(permission.permitAccessLevel3!)}
                onChange={(checked) =>
                {
                    const permitAccessLevel3 = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;
                    saveCustomerPermission({ permitAccessLevel3 } as CustomerPermissions);
                }} />
            <SettingsCheckbox

                text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_CONSTRUCTIONSPUSHLOWERLEVEL"}
                disabled={allowedToEdit ? !permissionAvailable(permission.notifyAllSystem!) : true}
                checked={permissionAllowed(permission.notifyAllSystem!)}
                onChange={(checked) =>
                {
                    const notifyAllSystem = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;
                    saveCustomerPermission({ notifyAllSystem } as CustomerPermissions);
                }} />
        </SettingsCol>
        <SettingsCol>
            <SettingsCheckbox
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_USEIFACCESSISENABLED"}
                disabled={!allowedToEdit}
                checked={permissionChecked(permission.restrictOperationToApprovedSession!)}
                onChange={(checked) =>
                {
                    const restrictOperationToApprovedSession = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;
                    saveCustomerPermission({ restrictOperationToApprovedSession } as CustomerPermissions);
                }} />
            {(permission.hideTreeBelow || allowedToEdit) ?
                <SettingsCheckbox
                    text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERERRICHTER"}
                    checked={permission.hideTreeBelow!}
                    disabled={!allowedToEdit}
                    onChange={(checked) =>
                    {
                        const hideTreeBelow = checked;
                        saveCustomerPermission({ hideTreeBelow } as CustomerPermissions);
                    }} />
                : null
            }
            {(permissionAllowed(permission.isAdmin!) || permissionAllowed(myPermissions.isAdmin!)) ?
                <SettingsCheckbox
                    text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERSUBADMIN"}
                    disabled={allowedToEdit ? !permissionAllowed(myPermissions.isAdmin!) || !permissionAvailable(permission.isAdmin!) : true}
                    checked={permissionChecked(permission.isAdmin!)}
                    onChange={(checked) =>
                    {
                        const isAdmin = checked ? InheritedPermission.ALLOWED : InheritedPermission.OFF;
                        saveCustomerPermission({ isAdmin } as CustomerPermissions);
                    }} /> : null
            }

            {(permissionAllowed(permission.createCustomer!) && permissionAllowed(permission.listAllSystems!)
                && !permission.hideTreeBelow
                && (permission.isReseller! || permissionAllowed(myPermissions.isAdmin!))) ?
                <SettingsCheckbox
                    text={`COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERWIEDERVERKAUF`}
                    disabled={!allowedToEdit ? !(permissionAllowed(myPermissions.isAdmin!)) : true}
                    checked={permission.isReseller || false}
                    onChange={(checked) =>
                    {
                        let isReseller = checked;
                        saveCustomerPermission({ isReseller } as CustomerPermissions);
                    }} />
                : null
            }

            {permissionAllowed(myPermissions.isAdmin!) ?
                <SettingsCheckbox
                    text={"COM_FACPMANAGEMENT_CUSTOMER_ACCOUNT_PERMISSIONS_USERWIEDERVERKAUF_DOMINANT"}
                    disabled={!allowedToEdit}
                    checked={permission.isReseller || false}
                    onChange={(checked) =>
                    {
                        let isReseller = checked;
                        saveCustomerPermission({ isReseller } as CustomerPermissions);
                    }} />
                : null
            }

        </SettingsCol>

    </>;
};

export default PermissionsSettings;
